<div class="col-md-12 mainDiv">
  <div class="col-md-12 headerDiv">
    <ol class="breadcrumb customBreadCrumb">
      <li><a href="">{{ 'global.menu.home'|translate }}</a></li>
      <li *ngIf="isAdmin"><a href="" class="active">{{'global.menu.admin.main'|translate}}</a></li>
      <li><a class="active">{{'global.menu.balance'|translate}}</a></li>
    </ol>
    <div class="col-md-12" *ngIf="serverError">
      <div class="alert alert-danger centertext">
        {{'error.server.not.reachable' | translate}}
      </div>
    </div>
    <div class="col-md-12" *ngIf="inMaintenance">
      <div class="alert alert-info centertext">
        {{'balance.messages.info.maintenance' | translate}}
      </div>
    </div>
    <div class="col-md-12 nobottommargin" *ngIf="isAdmin">
      <div class="col-md-4">
        &nbsp;
      </div>
      <div class="col-md-4 centertext nobottommargin">
        <div class="balance-form-group pmi_form_group">
          <input type="text" (keyup)="checkSearchString()" (keydown.enter)="requestBalance()" id="employeeid"
            [(ngModel)]="searchString" class="balanceSearchparamInput" autocomplete="off" autofocus required>
          <span class="bar"></span>
          <label class="balanceEmployeeLabel">{{ 'home.form.searchparam' | translate }}</label>
        </div>
      </div>
      <div class="col-md-4">
        &nbsp;
      </div>
    </div>
    <div class="col-md-12" *ngIf="isEmployee">
      <div class="col-md-2">
        &nbsp;
      </div>
      <div class="col-md-3 centertext">
        <label class="userInfoLabel">{{'person.name' | translate}}</label>
        <label>{{employeeName}}</label>
      </div>
      <div class="col-md-2">
        &nbsp;
      </div>
      <div class="col-md-3 centertext">
        <label class="userInfoLabel">{{'person.certificatenumber' | translate}}</label>
        <label>{{certificateNumber}}</label>
      </div>
      <div class="col-md-2">
        &nbsp;
      </div>
    </div>
    <ng-container *ngIf="progressIndicator == PROGRESS.LOADED">
      <div class="col-md-12 nobottommargin">
        <div class="col-md-4">
          &nbsp;
        </div>
        <div class="col-md-4 centertext">
          <button type="button"
                  class="btn btn-primary btnbalance" (click)="downloadBalance()">
            <span class="glyphicon glyphicon-file-pdf"></span>&nbsp; Print Report
          </button>
        </div>

        <div class="col-md-4">
          &nbsp;
        </div>
      </div>
      <div class="col-md-12 nobottommargin">
        <div class="col-md-4" *ngIf="showUnitPrice">
          &nbsp;
        </div>
        <div class="col-md-4 centertext" *ngIf="showUnitPrice">
          <p class="centertext">{{'balance.unit' | translate}}&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>{{unitPriceDate}}</strong></p>
        </div>

        <div class="col-md-4" *ngIf="showUnitPrice">
          &nbsp;
        </div>
      </div>
    </ng-container>
  </div>
  <form class="form-horizontal" [formGroup]="balanceFilterForm" novalidate (submit)="requestBalance()">
    <div class="col-md-12 globalMainPadding balanceFormDiv">
      <div class="col-md-2">
        &nbsp;
      </div>
      <div class="col-md-3 customCalendarDiv noBottomMargin">
        <label class="dobLabel">{{'global.form.from' | translate}} &nbsp;*</label>
        <input class="smallTxt"
               type="textbox"
               tooltip="Date"
               triggers="focus"
               formControlName="fromDateDay"
               maxlength="2"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setFromDate()"
               required>

        <input class="smallTxt"
               type="textbox"
               tooltip="Month"
               triggers="focus"
               formControlName="fromDateMonth"
               maxlength="2"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setFromDate()"
               required>

        <input class="smallTxt"
               type="textbox"
               tooltip="Year"
               triggers="focus"
               formControlName="fromDateYear"
               minlength="4"
               maxlength="4"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setFromDate()"
               required>

        <my-date-picker name="mydate"
                        [options]="myDatePickerOptions"
                        required
                        formControlName="balanceStartDate"
                        (dateChanged)="onFromDateCalendarChanged($event)"
                        required>
        </my-date-picker>
      </div>
      <div class="col-md-2">
      </div>
      <div class="col-md-3 customCalendarDiv noBottomMargin">
        <label class="dobLabel">{{'global.form.to' | translate}} &nbsp;*</label>
        <input class="smallTxt"
               type="textbox"
               tooltip="Date"
               triggers="focus"
               formControlName="toDateDay"
               maxlength="2"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setToDate()"
               required>

        <input class="smallTxt"
               type="textbox"
               tooltip="Month"
               triggers="focus"
               formControlName="toDateMonth"
               maxlength="2"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setToDate()"
               required>

        <input class="smallTxt"
               type="textbox"
               tooltip="Year"
               triggers="focus"
               name="toYearEdate"
               formControlName="toDateYear"
               required
               minlength="4"
               maxlength="4"
               (keypress)="keypressValidator.checkOnlyNumber($event)"
               (keyup)="setToDate()">

        <my-date-picker name="mydate2"
                        [options]="myDatePickerOptions"
                        required
                        formControlName="balanceEndDate"
                        (dateChanged)="onToDateCalendarChanged($event)"
                        required>
        </my-date-picker>
      </div>
      <div class="col-md-2">
        &nbsp;
      </div>
    </div>
    <div class="col-md-12 noBottomMargin" *ngIf="datepickerAlert.status">
      <div class="col-md-4 noBottomMargin">&nbsp;</div>
      <div class="col-md-4 noBottomMargin alert alert-info customMargin centertext">
        <!--Please choose month first-->
        {{ datepickerAlert.message }}
      </div>
      <div class="col-md-4 noBottomMargin">&nbsp;</div>
    </div>
    <div class="col-md-12 calendarDiv">
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
      <div class="col-md-3 noBottomMargin">
        <button type="button" class="btn btn-outline clearButn btnbalance" (click)="clearSearchData()">Clear</button>
      </div>
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
      <div class="col-md-3 noBottomMargin">
        <button type="submit" class="btn btn-primary btnbalance"
                [disabled]="!balanceFilterForm.valid || (datepickerAlert.status) || inMaintenance !== false  ">
          {{'document.search' | translate}}
        </button>
      </div>
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
    </div>
  </form>
  <div class="col-md-12" *ngIf="invalidDateRange">
    <div class="alert alert-danger customMargin centertext">
      {{'transaction.invalidrange'|translate}}
    </div>
  </div>
  <ng-container [ngSwitch]="progressIndicator">
    <div class="col-md-12 nopaddingmd-12" *ngSwitchCase="PROGRESS.LOADED">
      <div class="col-md-1 ">
        &nbsp;
      </div>
      <div class="col-md-3 ">
        &nbsp;
      </div>
      <div class="col-md-4 blanceHeading">
        {{'balance.mainheading'|translate}}
      </div>
      <div class="col-md-3 ">
        &nbsp;
      </div>
      <div class="col-md-1 ">
        &nbsp;
      </div>
      <div class="col-md-12 globalMainPadding">
        <table class="table table-scrollable table-striped balanceTable">
          <thead class="gray-thead">
          <tr>
            <th colspan="5">
              {{'balance.note'|translate}}
            </th>
            <th colspan="7" class="rightTextAlign">
              {{'balance.nominal'|translate}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="12" class="customdiv">
              {{'balance.table1.heading1'|translate}}
            </td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading1'|translate}}</td>
            <td colspan="7">{{contribution.EEContrib | commaSeparator}}</td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading2'|translate}}</td>
            <td colspan="7">{{contribution.TUEEContrib | commaSeparator}}</td>
          </tr>
          <tr>
            <td colspan="12" class="customdiv">
              {{'balance.table1.heading3'|translate}}
            </td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading3'|translate}}</td>
            <td colspan="7">{{contribution.ERContrib | commaSeparator}}</td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading2'|translate}}</td>
            <td colspan="7">{{contribution.TUERContrib | commaSeparator}}</td>
          </tr>
          <tr>
            <td colspan="12" class="customdiv">
              {{'balance.table1.heading4'|translate}}
            </td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv"> {{'balance.table1.heading4'|translate}}</td>
            <td colspan="7">{{contribution.transfer | commaSeparator}}</td>
          </tr>
          <tr>
            <td colspan="5" class="customLastdiv">
              {{'balance.table1.heading5'|translate}}
            </td>
            <td colspan="7" class="customLastdiv rightTextAlign">
              {{contribution.totalContrib | commaSeparator}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 globalMainPadding centertext ">
        {{'balance.tableMidData'|translate}}
        <button type="button" class="customPopoverBtn glyphicon glyphicon-info-sign"
                popover="{{'balance.info1'|translate}}."
                popoverTitle="" triggers="focus">
        </button>

      </div>
      <div class="col-md-12 globalMainPaddingNoBottom">
        <table class="table table-scrollable table-striped balanceTable">
          <thead class="gray-thead">
          <tr>
            <th colspan="5">
              {{'balance.note'|translate}}
            </th>
            <th colspan="7" class="rightTextAlign">
              {{'balance.nominal'|translate}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="12" class="customdiv">
              {{'balance.table1.heading6'|translate}}
            </td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading6'|translate}}</td>
            <td colspan="7">{{contribution.EEContribWD | commaSeparator}}</td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading7'|translate}}</td>
            <td colspan="7">{{contribution.TUEEContribWD | commaSeparator}}</td>
          </tr>
          <tr>
            <td colspan="12" class="customdiv">
              {{'balance.table1.heading8'|translate}}
            </td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv"> {{'balance.table1.heading8'|translate}}</td>
            <td colspan="7">{{contribution.ERContribWD | commaSeparator}}</td>
          </tr>
          <tr class="docTr">
            <td colspan="5" class="leftAlignDiv">{{'balance.table1.heading7'|translate}}</td>
            <td colspan="7">{{contribution.TUERContribWD | commaSeparator}}</td>
          </tr>
          <tr>
            <td colspan="5" class="customLastdiv">
              {{'balance.table1.heading9'|translate}}
            </td>
            <td colspan="7" class="customLastdiv rightTextAlign">
              {{contribution.totalWD | commaSeparator}}
            </td>
          </tr>
          <tr>
            <td colspan="5" class="customdiv">
              {{'balance.table1.heading12'|translate}}
            </td>
            <td colspan="7" class="customdiv rightTextAlign">
              {{contribution.totalFee | commaSeparator}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 globalMainPadding">
        <table class="table table-scrollable table-striped balanceTable">
          <tbody>
          <tr>
            <td colspan="5" class="customdiv">
              {{'balance.table1.heading10'|translate}}
              <button type="button" class="popOverBtn glyphicon glyphicon-info-sign"
                      popover="{{'balance.info2'|translate}}."
                      popoverTitle="" triggers="focus">
              </button>
            </td>
            <td colspan="7" class="customdiv rightTextAlign">
              {{contribution.contribBalance | commaSeparator}}
            </td>
          </tr>
          <tr>
            <td colspan="5" class="customdiv">
              {{'balance.table1.heading11'|translate}}
              <button type="button" class="popOverBtn glyphicon glyphicon-info-sign"
                      popover="{{'balance.info3'|translate}}."
                      popoverTitle="" triggers="focus">
              </button>
            </td>
            <td colspan="7" class="customdiv rightTextAlign">
              {{contribution.endBalance | commaSeparator}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 globalMainPadding">
        <table class="table table-scrollable table-striped balanceTable bottomBorder">
          <thead class="gray-thead">
          <tr colspan="12">
            <th colspan="6" class="lefttextAlign">
              {{'balance.table2.heading1'|translate}}
            </th>
            <th colspan="9" class="customTh">
              <table class="table table-scrollable table-striped nomargintable">
                <thead class="gray-thead">
                <tr>
                  <th colspan="9" class="customBorder">
                    {{'balance.table2.heading2'|translate}}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="3" class="customBackground">
                    {{'balance.table2.heading3'|translate}}
                  </td>
                  <td colspan="3" class="customBackground">
                    {{'balance.table2.heading4'|translate}}
                  </td>
                  <td colspan="3" class="customBackground">
                    {{'balance.table2.heading5'|translate}}
                  </td>
                </tr>

                </tbody>
              </table>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr colspan="12" *ngFor="let fundComposition of fundCompositions;let i = index;">
            <td colspan="6" *ngIf="lang !== 'en'" class="lefttextAlign">
              {{fundComposition.name}}
            </td>
            <td colspan="6" *ngIf="lang === 'en'" class="lefttextAlign">
              {{fundComposition.nameEN}}
            </td>
            <td colspan="3">
              {{fundComposition.ERComposition | commaSeparator}} %
            </td>
            <td colspan="3">
              {{fundComposition.EEComposition | commaSeparator}} %
            </td>
            <td colspan="3">
              {{fundComposition.TUComposition | commaSeparator}} %
            </td>
          </tr>

          </tbody>
        </table>
      </div>
      <div class="col-md-12 globalMainPaddingNoBottom">
        <table class="table table-scrollable table-striped balanceTable bottomBorder">
          <thead class="gray-thead">
          <tr colspan="12">
            <th colspan="6" class="lefttextAlign">
              {{'balance.table2.heading1'|translate}}
            </th>
            <th colspan="3">
              {{'balance.table2.heading6'|translate}} <br>
              {{'balance.table2.heading6A'|translate}}
            </th>
            <th colspan="3">
              {{'balance.table2.heading7'|translate}} <br>
              {{'balance.table2.heading7A'|translate}}
            </th>
            <th colspan="3" class="customTh">
              <table class="table table-scrollable table-striped nomargintable">
                <thead class="gray-thead">
                <tr>
                  <th colspan="6" class="customBorder">
                    {{'balance.table2.heading8'|translate}}
                    <button type="button" class="popOverBtn finalGlyhyBground glyphicon glyphicon-info-sign"
                            popover="{{'balance.info4'|translate}}."
                            popoverTitle="" triggers="focus">
                    </button>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td colspan="2" class="customBackground lessPaddedcell">
                    {{'balance.table2.heading9'|translate}}
                  </td>
                  <td colspan="2" class="customBackground lessPaddedcell">
                    {{'balance.table2.heading10'|translate}}
                  </td>
                  <td colspan="2" class="customBackground lessPaddedcell">
                    {{'balance.table2.heading11'|translate}}
                  </td>
                </tr>

                </tbody>
              </table>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr colspan="12" *ngFor="let fundPerformance of fundPerformances;let i = index;">
            <td colspan="6" *ngIf="lang !== 'en'" class="lefttextAlign">
              {{fundPerformance.name}}
            </td>
            <td colspan="6" *ngIf="lang === 'en'" class="lefttextAlign">
              {{fundPerformance.nameEN}}
            </td>
            <td colspan="3">
              {{fundPerformance.totalUnit | commaSeparator}}
            </td>
            <td colspan="3">
              {{fundPerformance.unitPrice | commaSeparator}}
            </td>
            <td colspan="1">
              {{fundPerformance.IR3 }}%
            </td>
            <td colspan="1">
              {{fundPerformance.IR6 }}%
            </td>
            <td colspan="1">
              {{fundPerformance.IR12 }}%
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-12 globalMainPadding">
      <div class="col-md-12 alert alert-info centertext" *ngSwitchCase="PROGRESS.TIMEOUT">
        {{'global.messages.info.timeout'|translate}}
      </div>
      <div class="col-md-12" *ngSwitchCase="PROGRESS.LOADING">
        <img class="loader" src="assets/images/loading.gif"/>
      </div>
      <div class="col-md-12 alert alert-info centertext" *ngSwitchCase="PROGRESS.NODATA">
        {{'global.messages.info.nodata' | translate}}
      </div>
    </div>
  </ng-container>
</div>
